import type { QuerySanitizer } from './types';
import { corporateProductsValidator, marketsValidator, segmentsValidator } from './sanitize';

export const corporateValidators: Record<string, QuerySanitizer> = {
  markets: marketsValidator,
  products: corporateProductsValidator,
  segments: segmentsValidator,
};
